import { ChipField, RadioButtonGroupInput, useRecordContext } from "react-admin";

const shoppingCartModeChoices = [
  { id: "default", name: "N/A" },
  { id: "purchase", name: "Purchase" },
  { id: "vote", name: "Vote" },
  { id: "url", name: "Other" },
];

export const ShoppingCartModeCheckboxGroupInput = (props) => {
  return (
    <RadioButtonGroupInput
      label="Shopping Cart Mode"
      source="mode"
      choices={shoppingCartModeChoices}
      initialValue="default"
      {...props}
    />
  );
};

export const ShoppingCartModeChipField = () => {
  const record = useRecordContext();
  const mode = record?.mode || "default";
  const choice = shoppingCartModeChoices.find((i) => i.id == mode) || shoppingCartModeChoices[0];

  return (
    <>
      <ChipField record={{ key: choice.id, name: choice.name }} source="name" />
    </>
  );
};
